import React, { Component } from 'react';
import { Grid } from 'react-bootstrap';

class App extends Component {

  render() {
    return (
      <div>
        { this.props.navbar }
        <Grid>
          { this.props.content }
        </Grid>
      </div>
    );
  }

}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/index.js